import { MealGroupConfig } from '@/plugins/api'

/**
 * Store Áp dụng (bữa × nhóm). Luôn truy vấn theo meal_slot.
 */
export default {
  namespaced: true,
  state: {
    configs: [],
    loading: false
  },
  actions: {
    async fetchBySlot({ commit }, slotId) {
      commit('changeState', { loading: true })
      const configs = await MealGroupConfig.fetch({ meal_slot: slotId, _limit: -1 })
      commit('changeState', { configs, loading: false })
    },
    async create(_, data) {
      return MealGroupConfig.create(data)
    },
    async update(_, { id, ...data }) {
      return MealGroupConfig.update(id, data)
    },
    async remove(_, id) {
      return MealGroupConfig.remove(id)
    }
  },
  mutations: {
    changeState(state, obj) {
      Object.assign(state, obj)
    }
  }
}
